import { Component, OnInit } from '@angular/core';
import { Router, Route, ActivatedRoute } from '@angular/router';
import { LoginService } from '../../providers/login.service';
import { FormControl, Validators } from '@angular/forms';
import { createSession } from '../../common/sessionHandler';
import { ApiPromisefactory } from '../../providers/promise.factory';
import { MethodSummary } from '../../models/methodSummary';
import { Params } from '../../models/params';
import { MethodServiceJava } from '../../providers/methodsService.java';
import { MethodServiceSwift } from '../../providers/methodsService.swift';
import { MethodServiceCordova } from '../../providers/methodsService.cordova';
import { LanguageSettings } from '../../providers/languageSettings.service';
import { MethodServiceDart } from '../../providers/methodsService.dart';

@Component({
  selector: 'app-blemodule',
  templateUrl: './bleclassmodule.html',
  styleUrls: ['./bleclassmodule.css']
})



export class ClassModuleComponent implements OnInit {

    language = 'html';
    className: String = '';
    methods: MethodSummary[];
    languageSubscription:any;
    selected:String;

    constructor(private _loginService: LoginService,
      private router: Router,
      private promiseSvc: ApiPromisefactory,
      private methodServiceJava: MethodServiceJava,
      private methodServiceSwift: MethodServiceSwift,
      private methodServiceCordova: MethodServiceCordova,
      private methodServiceDart: MethodServiceDart,
      private route: ActivatedRoute,
      private languageSettings: LanguageSettings
    ) {
        // this.methods = methodService.getSGBLEConnectMethods();
      }

   ngOnInit() {

    this.selected = this.languageSettings.getSelectedLanguage();
    this.languageSubscription = this.languageSettings.getLanguageChangeEmitter().subscribe(
      item => this.onValChange(item)
    )

    this.route.data
      .subscribe((data: { className: String }) => {
        this.className = data.className;
        this.getMethodService();
      });

  }

    onValChange(val) {
      this.selected = this.languageSettings.getSelectedLanguage();
      this.getMethodService();
      console.log("onvalchange: "+val);
    }


    getMethodService(){
      var service = this.getMethodServiceByLanguage(this.selected);

      switch (this.className){
        case "SGConnectEdge":
          this.methods = service.getSGConnectEdgeMethods();
          break;
        case "SGConnectBLE":
          this.methods = service.getSGBLEConnectMethods();
          break;
        case "SGLoggerDelegate":
          this.methods = service.getSGLogCallBackMethods();
          break;
        case "SGBLEObserver":
          this.methods = service.getSGBLEStatusCallBackMethods();
          break;
        case "SGSessionObserver":
          this.methods = service.getSGSessionStatusCallBackMethods();
          break;
        case "SGConnectQR":
          this.methods = service.getSGQRConnectEdgeMethods(); //todo: may be ok rename without 'edge'
          break;
        case "SGQRStatusCallback":
          this.methods = service.getSGQRStatusCallBackMethods();
          break;
        case "SGProxObserver":
          this.methods = service.getSGProxStatusCallBackMethods();
          break;
        case "SGPlayerProfileObserver":
          this.methods = service.getSGPlayerProfileCallBackMethods();
          break;
        case "SGPlayerBalanceCallback":
          this.methods = service.getSGPlayerBalanceCallBackMethods();
          break;
        case "SGFundTransferCallback":
          this.methods = service.getSGFundTransferCallbackMethods();
          break;
        case "SGFundTransferEdgeCallback":
          this.methods = service.getSGFundTransferEdgeCallbackMethods();
          break;
      }
    }

    getMethodServiceByLanguage(language:String){
      switch(language){
        case "Java":
          return this.methodServiceJava;
        case "Swift":
          return this.methodServiceSwift;
        case "JavaScript":
          return this.methodServiceCordova;
        case "Dart":
          return this.methodServiceDart;;
      }
    }

}
